import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportCost } from './Cost.service';
import reportNotificationError from '@/utils/functions/notificationErrorNetReport';

export function useCostReport() {
  return useMutation(getQuestReportCost, {
    onSuccess() {
      notification.success({
        message: 'Relatório de custo gerado com sucesso!',
      });
    },

    onError(error) {
      reportNotificationError(error);
    },
  });
}
